// js/custom-element/ui/carousel.js
document.addEventListener("critical-js:loaded", () => {
  if (!window.customElements.get("native-carousel")) {
    var NativeCarousel = class extends CustomHTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll("native-carousel-item"));
        this.pageDotsElements = Array.from(this.querySelectorAll("page-dots"));
        this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons"));
        if (this.items.length > 1) {
          this.addEventListener("prev-next:prev", this.prev.bind(this));
          this.addEventListener("prev-next:next", this.next.bind(this));
          this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index, true));
          if (Shopify.designMode) {
            this.addEventListener("shopify:block:select", (event) => this.select(event.target.index, !event.detail.load));
          }
        }
        const scrollerElement = this.items[0].parentElement;
        this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this), { root: scrollerElement, rootMargin: `${scrollerElement.clientHeight}px 0px`, threshold: 0.8 });
        this.items.forEach((item) => this.intersectionObserver.observe(item));

        this.dragEnabled = true;
        if(this.hasAttribute("draggable") && this.items.length > 1){
          this.dragStartX = 0;
          this.isDragging = false;

          this.addEventListener("mousedown", (event) => this._startDrag(event.clientX));
          this.addEventListener("touchstart", (event) => this._startDrag(event.touches[0].clientX));

          this.addEventListener("mousemove", window.throttle((event) => this._handleDrag(event.clientX), 100));
          this.addEventListener("touchmove", window.throttle((event) => this._handleDrag(event.touches[0].clientX), 100));

          this.addEventListener("mouseup", () => this._endDrag());
          this.addEventListener("touchend", () => this._endDrag());
        }
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this.intersectionObserver.disconnect();
      }
      get selectedIndex() {
        return this.items.findIndex((item) => item.selected);
      }
      prev(shouldAnimate = true) {
        this.select(Math.max(this.selectedIndex - 1, 0), shouldAnimate);
      }
      next(shouldAnimate = true) {
        this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), shouldAnimate);
      }
      select(index, shouldAnimate = true) {
        const previousIndex = this.selectedIndex;
        const clampIndex = Math.max(0, Math.min(index, this.items.length));
        const selectedElement = this.items[clampIndex];
        this._adjustNavigationForElement(selectedElement);
        if (shouldAnimate) {
          this.items.forEach((item) => this.intersectionObserver.unobserve(item));
          setInterval(() => {
            this.items.forEach((item) => this.intersectionObserver.observe(item));
          }, 800);
        }
        this.items.forEach((item, loopIndex) => {
          item.selected = loopIndex === clampIndex;
          item.classList.toggle("animate", loopIndex === clampIndex || loopIndex === previousIndex);
        });
        const direction = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
        selectedElement.parentElement.scrollTo({ left: direction * (selectedElement.clientWidth * clampIndex), behavior: shouldAnimate ? "smooth" : "auto" });
        this.dispatchEvent(new CustomEvent("slide-changed", {
          detail: { previous: previousIndex, current: clampIndex },
        }));
      }
      _adjustNavigationForElement(selectedElement) {
        this.items.forEach((item) => item.selected = selectedElement === item);
        this.pageDotsElements.forEach((pageDot) => pageDot.selectedIndex = selectedElement.index);
        this.prevNextButtonsElements.forEach((prevNextButton) => {
          prevNextButton.isPrevDisabled = selectedElement.index === 0;
          prevNextButton.isNextDisabled = selectedElement.index === this.items.length - 1;
        });
      }
      _onVisibilityChanged(entries) {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            this._adjustNavigationForElement(entry.target);
            break;
          }
        }
      }
      
      _startDrag(clientX) {
        if(this.dragEnabled) {
          this.isDragging = true;
          this.dragStartX = clientX;
        }
      }

      _handleDrag(clientX) {
        if (!this.isDragging) {
          return;
        }

        const dragDelta = clientX - this.dragStartX;
        if(dragDelta > 30) {
          this._endDrag();
          this.prev();
        } else if (dragDelta < -30) {
          this._endDrag();
          this.next();
        }
      }

      _endDrag() {
        if (!this.isDragging) {
          return;
        }

        this.isDragging = false;
        this.dragStartX = 0;
      }
    };
    window.customElements.define("native-carousel", NativeCarousel);
  }

  if (!window.customElements.get("native-carousel-item")) {
    var NativeCarouselItem = class extends CustomHTMLElement {
      static get observedAttributes() {
        return ["hidden_block"];
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden_block");
      }
      set selected(value) {
        if (value) {
          this.removeAttribute("hidden_block");
        } else {
          this.setAttribute("hidden_block", "");
        }
      }
    };
    window.customElements.define("native-carousel-item", NativeCarouselItem);
  }
})